module.exports = __webpack_public_path__ + "static/media/1022192.acd886a3.jpg";